import { NgModule } from '@angular/core';

import { DashboardWidgetSelectComponent } from './dashboard-widget-select.component';
import { DashboardWidgetComponent } from './dashboard.widget.component';

@NgModule({
  imports: [DashboardWidgetComponent, DashboardWidgetSelectComponent],
  exports: [DashboardWidgetComponent, DashboardWidgetSelectComponent],
})
export class DashboardWidgetModule {}
